import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/protected/_layout/service-contracts/_layout/'
)({
  component: () => null,
});
